import { useContext, useState } from "react"

//PrimeReact
import { InputSwitch } from "primereact/inputswitch"
import { ConfirmDialog } from "primereact/confirmdialog" // For <ConfirmDialog /> component
import { confirmDialog } from "primereact/confirmdialog" // For confirmDialog method

//Assessments components
import {
  assessmentsApiSharedAssessmentPost,
  assessmentsApiSystemAssessmentPost,
} from "../assessmentsApi"
import { LoaderSmall } from "../../../components/Loaders"

// Context
import { UserContext } from "../../../context/userContext"
import { LogError } from "../../../helpers/logger"

//Styles
import assessStyles from "../../../styles/assessments/Assessment.module.css"

export default function AssessmentListTableStatus({ rowData }) {
  const userCtx = useContext(UserContext)

  const [isActive, setIsActive] = useState(
    rowData.isSystemType
      ? !rowData.isSystemTypeDisabled
      : !rowData.shareIsDisabled
  )
  const [isLoading, setIsLoading] = useState(false)

  const assessmentText = rowData.isSystemType ? "system" : "shared"
  const entityText = rowData.isSystemType ? "enterprise" : "organization"

  const updateStats = async (active) => {
    setIsLoading(true)
    try {
      if (rowData.isSystemType) {
        await assessmentsApiSystemAssessmentPost(userCtx.tokenAssessments, {
          assessmentId: rowData.id,
          enterpriseId: userCtx.session.user.enterprise_id,
          enterpriseAlias: rowData.enterpriseAlias,
          isDisabled: !active,
          userId: userCtx.session.user.staff_id,
        })
      } else {
        await assessmentsApiSharedAssessmentPost(userCtx.tokenAssessments, {
          assessmentId: rowData.id,
          organizationId: userCtx.session.user.organization_id,
          isDisabled: !active,
          userId: userCtx.session.user.staff_id,
        })
      }

      setIsActive(active)
      setIsLoading(false)
    } catch (error) {
      LogError(`Unable to update ${assessmentText} assessment status`, error)
      userCtx.setNotificationError(
        `Unable to update ${assessmentText} assessment status`
      )
      setIsLoading(false)
    }
  }

  if (rowData.accessLevel === "public") {
    return <></>
  }

  if (isLoading) {
    return <LoaderSmall />
  } else {
    const message = isActive
      ? `Are you sure that you want to disable this ${assessmentText} assessment for the ${entityText}?`
      : `Are you sure that you want to enable this ${assessmentText} assessment for the ${entityText}?`

    return (
      <div className={assessStyles.switchControl}>
        <ConfirmDialog />
        <InputSwitch
          checked={isActive}
          disabled={false}
          onChange={(e) => {
            confirmDialog({
              message: message,
              header: "Confirmation",
              icon: "pi pi-exclamation-triangle",
              defaultFocus: "accept",
              accept: () => {
                updateStats(e.value)
              },
              reject: undefined,
            })
          }}
          tooltip={
            isActive
              ? `Disable ${assessmentText} assessment for this ${entityText}`
              : `Enable ${assessmentText} assessment for this ${entityText}`
          }
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    )
  }
}
